(function() {
  document.addEventListener('change', function(event) {
    var selectedOption = event.target;

    if (!selectedOption.matches('.product-option-boxes[data-hide-second-option="true"] .single-option-selector__radio[data-linked-option2-value]')) {
      return;
    }

    var optionsContainer = selectedOption.closest('.product-option-boxes[data-hide-second-option="true"]');
    var option2Value = selectedOption.getAttribute('data-linked-option2-value');

    if (!option2Value || !optionsContainer) {
      return;
    }

    var option2Inputs = optionsContainer.querySelectorAll('.single-option-selector__radio[data-index="option2"]');

    Array.prototype.some.call(option2Inputs, function(option) {
      if (option.value !== option2Value) {
        return false;
      }

      option.checked = true;
      return true;
    });
  }, true);
})();
